import { reducerWithInitialState } from "util/redux/typed-reducers";
import actionCreatorFactory from "util/redux/action-factory";
import { ReduxDispatch } from "./reducers";
import * as request from "../util/request";
import { env } from "util/env";
import { CreditCardDto, CreditCardDetailsDto } from "util/DTOs/CreditCardDtos";

const ACTION_CREATOR = actionCreatorFactory("HypoMobiili/CreditCard");
export const loadCreditCards = ACTION_CREATOR<
    undefined,
    CreditCardDto[],
    string
>("LOAD_CREDIT_CARDS");
export const loadCreditCard = ACTION_CREATOR<
    string,
    CreditCardDetailsDto,
    string
>("LOAD_SINGLE_CREDIT_CARD");
export interface ICreditCardState {
    cards?: CreditCardDto[];
    details?: CreditCardDetailsDto[];
}

const initialState = {
    cards: undefined,
    details: undefined,
};

export const CreditCardReducer = reducerWithInitialState<ICreditCardState>(
    initialState
)
    .case(loadCreditCards, (state, action) => {
        return state;
    })
    .case(loadCreditCards.done, (state, action) => {
        return { ...state, cards: action.payload };
    })
    .case(loadCreditCards.failed, (state, action) => {
        return state;
    })
    .case(loadCreditCard, (state, action) => {
        return state;
    })
    .case(loadCreditCard.done, (state, action) => {
        const details = state.details || [];
        const index = details.findIndex(
            (n) => n.card.customerCardId === action.payload.card.customerCardId
        );
        if (index === -1) {
            details.push(action.payload);
        }
        return { ...state, details };
    })
    .case(loadCreditCard.failed, (state, action) => {
        return state;
    });

export default CreditCardReducer;

export function getCreditCards() {
    return async (dispatch: ReduxDispatch) => {
        try {
            dispatch(loadCreditCards(undefined));

            let result = await request.get<CreditCardDto[]>(
                `${env.APP_API_HOST}/api/creditcards`
            );

            dispatch(loadCreditCards.done(result));
        } catch (error) {
            dispatch(loadCreditCards.failed("Error loading credit cards data"));
            throw error;
        }
    };
}

export function getCreditCardById(id: string) {
    return async (dispatch: ReduxDispatch) => {
        try {
            dispatch(loadCreditCard(id));

            let result = await request.get<CreditCardDetailsDto>(
                `${env.APP_API_HOST}/api/creditcards/${id}`
            );

            dispatch(loadCreditCard.done(result));
        } catch (error) {
            dispatch(loadCreditCard.failed("Error loading credit cards data"));
            throw error;
        }
    };
}



// WEBPACK FOOTER //
// ./src/ducks/creaditcard.ts